unable to read source [project]/workspace/frontend/src/core/addOverlayLayer.ts